import { render, staticRenderFns } from "./actions-set-more-menu.vue?vue&type=template&id=50cfe3ae&scoped=true&"
import script from "./actions-set-more-menu.vue?vue&type=script&lang=js&"
export * from "./actions-set-more-menu.vue?vue&type=script&lang=js&"
import style0 from "./actions-set-more-menu.vue?vue&type=style&index=0&id=50cfe3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cfe3ae",
  null
  
)

export default component.exports